/** Drive sync rows use this title prefix (see driveFolder.ts). */
export const DRIVE_FOLDER_NOTICE_TITLE_PREFIX = /^Drive folder:\s*/i;

export type CircleStatsNotice = {
  isDeleted?: boolean;
  isDraft?: boolean;
  targetSubcircle?: string;
  title?: string;
  attachments?: unknown[] | null;
};

export type CircleContentStats = {
  noticeCount: number;
  driveFileCount: number;
};

export function isDriveFolderBackingNotice(title?: string): boolean {
  return DRIVE_FOLDER_NOTICE_TITLE_PREFIX.test((title ?? "").trim());
}

/** Published notices + drive attachments scoped to a subcircle. */
export function computeCircleContentStats(
  notices: CircleStatsNotice[],
  subcircleId: string
): CircleContentStats {
  let noticeCount = 0;
  let driveFileCount = 0;

  for (const notice of notices) {
    if (notice.isDeleted || notice.isDraft) continue;
    if (notice.targetSubcircle !== subcircleId) continue;

    const attachmentCount = Array.isArray(notice.attachments)
      ? notice.attachments.length
      : 0;
    driveFileCount += attachmentCount;

    if (!isDriveFolderBackingNotice(notice.title)) {
      noticeCount += 1;
    }
  }

  return { noticeCount, driveFileCount };
}
